export default __webpack_public_path__ + "static/media/step2.9122bc47.svg";